import { usePage } from '@inertiajs/vue3';
import { onMounted, ref, watch } from 'vue';

const isMobile = ref(false);

const updateIsMobile = () => {
    if (typeof window === 'undefined') {
        try {
            const page = usePage();
            const deviceType = page.props.deviceType;
            isMobile.value = deviceType === 'mobile';
        } catch (e) {
            console.error('Error during SSR:', e);
            isMobile.value = false;
        }
    } else {
        // Check for touch capabilities
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Check for mobile user agent
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobileDevice = /iphone|ipad|ipod|android|webos|blackberry|iemobile|opera mini/i.test(userAgent);

        // Check screen width
        const isSmallScreen = window.innerWidth < 768;

        isMobile.value = hasTouch && (isMobileDevice || isSmallScreen);
    }
};

export default function useIsMobile() {
    const page = usePage();
    
    watch(() => page.props.deviceType, (newDeviceType) => {
        if (newDeviceType) {
            isMobile.value = newDeviceType === 'mobile';
        }
    }, { immediate: true });

    if (typeof window !== 'undefined') {
        onMounted(() => {
            updateIsMobile();
            window.addEventListener('resize', updateIsMobile);
        });
    } else {
        updateIsMobile();
    }

    return {
        isMobile,
    };
}
